import { nativeApi } from '@/../../common/src/utils/nativeApi';
import { useNavigate } from 'react-router-dom';
import style from './index.module.less';
import jqqd from './jqqd.png';
import wlyc from './wlyc.png';
import wxyk from './wxyk.png';
import zwjl from './zwjl.png';
import zwxx from './zwxx.png';
import zwyhq from './zwyhq.png';

import { t } from 'i18next';

/* eslint-disable */
export type CommonEmptyProps = {
  type?: 'jqqd' | 'wlyc' | 'zwxx' | 'zwyhq' | 'zwjl' | 'wxyk'; // 默认的空类型
  title?: string; // 指定标题
  imgurl?: string; // 指定图片路径
  tips?: string; // 指定提示语
  clsName?: string; //额外样式
  btn?: string; // 指定按钮文案
  btnClick?: () => void; // 指定按钮点击事件

  // 优先级更高
  hideTitle?: boolean; // 是否隐藏标题
  hideTips?: boolean; // 是否隐藏提示语
  hideBtn?: boolean; // 是否隐藏按钮
  hideImg?: boolean; // 是否隐藏图片
};
/* eslint-enable */

function CommonEmpty(props: CommonEmptyProps) {
  const navigate = useNavigate();
  const naviBack = () => {
    if (history.state === null || history.state.idx === 0 || history.length === 1) {
      nativeApi.closeWindow();
    } else {
      navigate(-1);
    }
  };

  const defaultType = {
    zwjl: {
      title: t('common.empty.zwjl'),
      imgurl: zwjl,
      btn: t('common.empty.fh'),
      btnClick: naviBack,
    },
    jqqd: {
      title: t('common.empty.jqqd'),
      imgurl: jqqd,
      btn: t('common.empty.fh'),
      btnClick: naviBack,
    },
    wlyc: {
      title: t('common.empty.wlyc'),
      imgurl: wlyc,
    },
    zwxx: {
      title: t('common.empty.zwxx'),
      imgurl: zwxx,
      tips: t('common.empty.zwxxtips'),
      btn: t('common.empty.fh'),
      btnClick: naviBack,
    },
    zwyhq: {
      title: t('coupon.list.no'),
      imgurl: zwyhq,
      btn: t('common.empty.fh'),
      btnClick: naviBack,
    },
    wxyk: {
      title: t('common.empty.wxyk'),
      imgurl: wxyk,
      btn: t('common.empty.wxykbtn'),
    },
  };
  const allInfo = {
    ...defaultType.zwjl, // 默認暫無記錄
    ...(props?.type ? defaultType[props.type] : {}), // 指定的type
    ...props, // 指定自定義
  };
  const {
    title,
    imgurl,
    tips,
    btn,
    hideTitle,
    hideTips,
    hideBtn,
    hideImg,
    btnClick,
    clsName = '',
  } = allInfo;

  const btnClickHanddle = () => {
    if (btnClick) {
      btnClick();
    }
  };

  return (
    <div className={`${style.empty} ${clsName}`}>
      {!hideImg && imgurl && <img src={imgurl} alt="" className={style.img} />}
      {!hideTitle && title && <div className={style.title}>{title}</div>}
      {!hideTips && tips && <div className={style.tips}>{tips}</div>}
      {!hideBtn && btn && (
        <div className={style.btn} onClick={btnClickHanddle}>
          {btn}
        </div>
      )}
    </div>
  );
}

export default CommonEmpty;
